import createPersistedState from 'vuex-persistedstate'

export default {
    namespaced: true,
    actions: {
        addRouteRecord({
            commit
        }, route) {
            commit('ADD_HISTORY', route)
        },

        popRouteRecord({
            commit
        }) {
            commit('POP_HISTORY')
        }
    },
    mutations: {
        addCart(state, payload) {
            state.cart.push(payload);
        },
        deleteCart(state, payload) {
            state.cart.splice(payload, 1);
        },
        CHANGE(state, payload) {
            state.changeData = payload;
        },
    },

    state: () => ({
        cart: [],
        changeData: {
            username: "",
            password: "",
            nodeType: "",
            nodeList: [],
            game: "",
            ipUserid: "",
            
        },
    }),
    plugins: [
        createPersistedState({
            storage: window.localStorage,
            paths: ['cart', 'changeData']
        })
    ],
    getters: {

    }
}